import { extend } from "@react-three/fiber";
import { SparkRenderer } from "@sparkjsdev/spark";

extend({ SparkRenderer });
